export enum SchedulingType {
  LiveWhenPublished = 'liveWhenPublished',
  Schedule = 'schedule',
}
